type TextRow = Record<string, unknown>;

function datasheetTextRowMergeKey(row: TextRow): string | undefined {
  if (typeof row.idKey === "number" && row.idKey >= 0) {
    return `idKey:${row.idKey}`;
  }
  if (typeof row.idKey === "string" && row.idKey !== "") {
    return `idKey:${row.idKey}`;
  }
  if (typeof row.id === "number") {
    return `id:${row.id}`;
  }
  return undefined;
}

export function mergeDatasheetFormatTextsWithDataTexts(
  formatTexts: TextRow[] | undefined,
  dataTexts: TextRow[] | undefined
): TextRow[] {
  if (!dataTexts?.length) {
    return (formatTexts ?? []) as TextRow[];
  }
  if (!formatTexts?.length) {
    return dataTexts as TextRow[];
  }

  const dataByKey = new Map<string, TextRow>();
  for (const row of dataTexts) {
    const key = datasheetTextRowMergeKey(row);
    if (key !== undefined) {
      dataByKey.set(key, row);
    }
  }

  return formatTexts.map((formatRow, index) => {
    const key = datasheetTextRowMergeKey(formatRow);
    const dataRow =
      key !== undefined ? dataByKey.get(key) : dataTexts[index];
    if (!dataRow) {
      return formatRow;
    }
    return { ...formatRow, ...dataRow };
  });
}
